module.exports = __webpack_public_path__ + "static-v-shop/1786392158156/img/logo-selma.9ebdc92a.png";